import { PROOF_OF_IDENTITY_DOCUMENTS } from '@/constants/documents';
import { Onboarding } from '@/services/requests/onboarding/Onboarding.types';
import { LoadedDocument, OnboardingDocument, UnionDocument } from '@/types/interfaces/Document.interface';

export const formatOnboardingUserData = <T extends Onboarding.UserDocuments>(data: T): T => {
  if (!(data && (data.personalDocuments || data.documents))) return data;
  if (data?.personalDocuments) {
    const formattedDocuments: Record<UnionDocument, Partial<OnboardingDocument>> = {} as Record<UnionDocument, OnboardingDocument>;
    Object.entries(data.personalDocuments).forEach(([type, document]) => {
      const documentType = type as typeof PROOF_OF_IDENTITY_DOCUMENTS[0];
      if (PROOF_OF_IDENTITY_DOCUMENTS.includes(documentType)) {
        if (!formattedDocuments.PROOF_OF_IDENTITY) {
          formattedDocuments.PROOF_OF_IDENTITY = {};
        }
        // @ts-ignore TODO: cleanup document types
        formattedDocuments.PROOF_OF_IDENTITY[document.type] = document;
      } else {
        formattedDocuments[documentType] = document;
      }
    });
    return {
      ...data,
      personalDocuments: formattedDocuments,
    };
  }
  const documents: Record<UnionDocument, OnboardingDocument> = {} as Record<UnionDocument, OnboardingDocument>;
  // @ts-ignore TODO: cleanup document types
  Object.entries(data.documents).forEach(([type, document]) => {
    documents[type as UnionDocument] = {
      type: type as UnionDocument,
      pages: [{
        side: 'UNSPECIFIED',
        fileDocument: document,
      }],
    };
  });
  return {
    ...data,
    personalDocuments: documents,
  };
};

export function formatOnboardingPersonalDocuments(
  personalDocuments: Record<UnionDocument, OnboardingDocument>,
): Record<UnionDocument, Partial<OnboardingDocument>> {
  return Object.entries(personalDocuments).reduce((acc, [type, document]) => {
    const documentType = type as typeof PROOF_OF_IDENTITY_DOCUMENTS[0];
    if (PROOF_OF_IDENTITY_DOCUMENTS.includes(documentType)) {
      if (!acc.PROOF_OF_IDENTITY) {
        acc.PROOF_OF_IDENTITY = {};
      }
      // @ts-ignore TODO: cleanup document types
      acc.PROOF_OF_IDENTITY[document.type] = document;
    } else {
      acc[documentType] = document;
    }

    return acc;
  }, {} as Record<UnionDocument, Partial<OnboardingDocument>>);
}

export function formatOnboardingDocuments(documents: Record<UnionDocument, LoadedDocument>) {
  const formattedDocuments: Record<UnionDocument, OnboardingDocument> = {} as Record<UnionDocument, OnboardingDocument>;
  Object.entries(documents).forEach(([type, document]) => {
    formattedDocuments[type as UnionDocument] = {
      type: type as UnionDocument,
      pages: [{
        side: 'UNSPECIFIED',
        fileDocument: document,
      }],
    };
  });
  return formattedDocuments;
}
